/*
* Created on Apr 01, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {createContext, useContext, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";

const GLOBAL = 'GLOBAL';
const CHINA = 'CHINA';

const RegionContext = createContext(null);
export const useRegion = () => useContext(RegionContext);


const RegionProvider= ({children}) => {
    const [region, setRegion] = useState(GLOBAL);
    const {i18n} =  useTranslation();

    const getCurrentDomainRegion = () => {
        if (window.location.hostname?.toLocaleLowerCase().endsWith('cn')) {
            return CHINA
        }
        return GLOBAL;
    }

    const selectRegion = (reg, param_string) => {
        setRegion(reg.toUpperCase());
        const param = param_string ? `?${param_string}` : ''
        if (reg === CHINA) {
            window.location.href = `${window._env_.REACT_APP_ORGANIZATION_CENTER_DOMAIN_CN}${param}`
        }
        else {
            window.location.href = `${window._env_.REACT_APP_ORGANIZATION_CENTER_DOMAIN}${param}`
        }
    }
    const get_acc_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_ACC_URL_CN : window._env_.REACT_APP_ACC_URL;
    const get_oauth_api_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_OAUTH_API_URL_CN : window._env_.REACT_APP_OAUTH_API_URL;
    const get_org_api_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_ORGANIZATION_API_URL_CN : window._env_.REACT_APP_ORGANIZATION_API_URL;
    const get_org_center_domain = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_ORGANIZATION_CENTER_DOMAIN_CN : window._env_.REACT_APP_ORGANIZATION_CENTER_DOMAIN;
    const get_cdn_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_CDN_URL_CN : window._env_.REACT_APP_CDN_URL;
    const get_myqnapcloud_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_MYQNAPCLOUD_API_CHINA_URL : window._env_.REACT_APP_MYQNAPCLOUD_API_URL;
    const get_myqnapcloud_fe_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_MYQNAPCLOUD_CHINA_URL : window._env_.REACT_APP_MYQNAPCLOUD_URL;
    const get_cms_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_CMS_URL_CHINA : window._env_.REACT_APP_CMS_URL;
    const get_service_status_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_SERVICES_STATUS_CHINA : window._env_.REACT_APP_SERVICES_STATUS;
    const get_license_manager_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_LICENSE_SHOP_URL_CN : window._env_.REACT_APP_LICENSE_SHOP_URL;
    const get_qnap_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_QNAP_URL_CN : `${window._env_.REACT_APP_QNAP_URL}`;
    const get_qnap_support_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_QNAP_SUPPORT_URL_CHINA : window._env_.REACT_APP_QNAP_SUPPORT_URL;
    const get_q2_api_url = () => getCurrentDomainRegion() === CHINA ? window._env_.REACT_APP_Q2_API_URL_CN : window._env_.REACT_APP_Q2_API_URL;
    const url = {
        get_acc_url,
        get_oauth_api_url,
        get_org_api_url,
        get_org_center_domain,
        get_cdn_url,
        get_myqnapcloud_url,
        get_myqnapcloud_fe_url,
        get_cms_url,
        get_service_status_url,
        get_license_manager_url,
        get_qnap_url,
        get_qnap_support_url,
        get_q2_api_url
    }

    useEffect(()=>{
        if (window.location.hostname?.toLocaleLowerCase().endsWith('cn')) {
            setRegion(CHINA);
            if (window._env_.REACT_APP_STRICT_CHINA_REGION) {
                i18n.changeLanguage('zh')
            }
        }
        else {
            setRegion(GLOBAL);
        }
    }, []);

    return (
        <RegionContext.Provider value={{region, selectRegion, url, getCurrentDomainRegion}}>
            {children}
        </RegionContext.Provider>
    );
};

export default RegionProvider;